const APP_NAME = {
    ios: 'CashNote Ifrit',
    android: 'CashNote Albatross',
};
const APP_FEATURE_MIN_SUPPORT_VERSION = {
    android: {
        openbanking: 'dev',
        실시간배달앱스크래핑: '2.2132.93',
        로컬인증서사용불가: '2.2148.99',
        급여명세서: '2.2213.105',
        앱보안설정: '1.0.0',
        passcodeAuth: '2.2236.118',
        마이데이터: 'dev',
        보안키패드: '2.2244.121',
        오픈소스라이선스: 'dev',
        홈택스간편인증: '2.2248.125',
        노란우산청약서비스: '2.2309.137',
        앱휴대폰본인인증: '2.2308.135',
        마이데이터v2: '2.2329.176',
        실시간우리카드스크래핑: '2.2328.175',
        이니시스카드결제: '2.2321.162', // 가시성 이슈로 인한 최소 지원 분기: slack 참고 - https://koreacreditdata.slack.com/archives/C021WQGP0SC/p1690266431397379?thread_ts=1690264518.969869&cid=C021WQGP0SC
    },
    ios: {
        openbanking: 'dev',
        실시간배달앱스크래핑: '2.2135.152',
        로컬인증서사용불가: '1.0.0',
        급여명세서: '999',
        앱보안설정: '2.2227.231',
        passcodeAuth: '2.2237.270',
        마이데이터: '2.2242.296',
        보안키패드: '2.2242.296',
        오픈소스라이선스: '2.2250.321',
        홈택스간편인증: '2.2248.316',
        노란우산청약서비스: '2.2312.376',
        앱휴대폰본인인증: '2.2312.376',
        마이데이터v2: '2.2325.418',
        실시간우리카드스크래핑: '2.2327.430',
        이니시스카드결제: '999', // ios는 개발 필요없음.
    },
};

export { APP_FEATURE_MIN_SUPPORT_VERSION, APP_NAME };
//# sourceMappingURL=constants.js.map
